import React from 'react';
import { Helmet } from 'react-helmet';
import Button from '../components/ui/Button';
export default function About() {
  return <main className="min-h-screen bg-white" data-id="element-387">
      <Helmet data-id="element-388">
        <title data-id="element-389">About Dr Imtiaz Syed | Expert Witness Psychiatrist UK</title>
        <meta name="description" content="Dr Imtiaz Syed is a GMC-registered psychiatrist and accredited expert witness with over 20 years of experience in medico-legal psychiatric assessments across the UK." data-id="element-390" />
        <meta name="keywords" content="Dr. Imtiaz Syed, GMC registered psychiatrist expert witness UK, MedCo accredited psychiatric expert witness, Psychiatric Expert for Solicitors and Barristers, Expert Witness Psychiatrist UK" data-id="element-391" />
        <script type="application/ld+json" data-id="element-392">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Person",
              "name": "Dr. Imtiaz Syed",
              "jobTitle": "Psychiatrist & Expert Witness",
              "description": "GMC-registered psychiatrist with over 20 years of clinical experience, providing expert witness services across the UK.",
              "memberOf": [
                {
                  "@type": "Organization",
                  "name": "Royal College of Psychiatrists"
                },
                {
                  "@type": "Organization",
                  "name": "MedCo"
                },
                {
                  "@type": "Organization",
                  "name": "General Medical Council"
                }
              ],
              "knowsAbout": ["Psychiatry", "Mental Capacity Assessments", "PTSD Evaluations", "Forensic Psychiatry", "ADHD Assessments", "Expert Witness Testimony"]
            }
          `}
        </script>
      </Helmet>
      {/* Hero Section */}
      <section className="bg-primary text-white py-10 pt-24 md:pt-28" data-id="element-393">
        <div className="container mx-auto px-4" data-id="element-394">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4 text-center" data-id="element-395">
            About Dr. Imtiaz Syed – Medico-Legal Psychiatrist & Expert Witness
          </h1>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-12" data-id="element-396">
        <div className="container mx-auto px-4" data-id="element-397">
          <div className="flex flex-col lg:flex-row gap-12" data-id="element-398">
            <div className="lg:w-1/3" data-id="element-399">
              <div className="sticky top-24" data-id="element-400">
                <div className="bg-gray-50 rounded-lg p-6 shadow-md" data-id="element-401">
                  <h3 className="text-xl font-serif font-bold text-primary mb-4" data-id="element-402">
                    Areas of Specialism
                  </h3>
                  <ul className="space-y-2 text-slate" data-id="element-403">
                    <li className="flex items-start" data-id="element-404">
                      <span className="text-secondary mr-2" data-id="element-405">•</span>
                      <span data-id="element-406">
                        Immigration Cases (psychological impact of
                        deportation/removal)
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-407">
                      <span className="text-secondary mr-2" data-id="element-408">•</span>
                      <span data-id="element-409">Deprivation of Liberty Safeguards (DoLS)</span>
                    </li>
                    <li className="flex items-start" data-id="element-410">
                      <span className="text-secondary mr-2" data-id="element-411">•</span>
                      <span data-id="element-412">Mental Capacity Assessments UK</span>
                    </li>
                    <li className="flex items-start" data-id="element-413">
                      <span className="text-secondary mr-2" data-id="element-414">•</span>
                      <span data-id="element-415">PTSD & Complex Trauma Evaluations</span>
                    </li>
                    <li className="flex items-start" data-id="element-416">
                      <span className="text-secondary mr-2" data-id="element-417">•</span>
                      <span data-id="element-418">ADHD & Autism in legal contexts</span>
                    </li>
                  </ul>
                  <div className="mt-6" data-id="element-419">
                    <Button variant="primary" href="/contact" className="w-full" data-id="element-420">
                      Instruct Dr. Syed
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-2/3" data-id="element-421">
              <div className="prose max-w-none" data-id="element-422">
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-423">
                  Your Trusted Medico-Legal Psychiatry Expert
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-424">
                  Dr. Imtiaz Syed is a highly experienced and compassionate
                  Psychiatrist, dedicated to providing clear, impartial, and
                  expert medico-legal assessments. With over 20 years of
                  extensive experience in both clinical practice and secure
                  online consultations, Dr. Syed brings a wealth of knowledge
                  and a deep understanding to every case.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-425">
                  A Committed and Reputable Expert Witness
                </h2>
                <p className="text-slate-dark mb-4" data-id="element-426">
                  As a GMC-registered psychiatrist, Dr. Syed specializes in a
                  range of complex medico-legal areas, including:
                </p>
                <ul className="list-disc pl-6 mb-6 text-slate-dark" data-id="element-427">
                  <li className="mb-2" data-id="element-428">
                    <strong data-id="element-429">Immigration Cases:</strong> Assessing the profound
                    psychological impact of removal or deportation, and
                    evaluating potential risks upon return to an individual's
                    home country.
                  </li>
                  <li className="mb-2" data-id="element-430">
                    <strong data-id="element-431">Deprivation of Liberty Safeguards (DoLS):</strong>{' '}
                    Ensuring individuals' rights are upheld by conducting
                    thorough assessments regarding their capacity to make
                    decisions within the framework of the Mental Capacity Act
                    2005.
                  </li>
                  <li data-id="element-432">
                    <strong data-id="element-433">Mental Capacity Assessments:</strong> Meticulously
                    evaluating an individual's ability to understand, retain,
                    use, and weigh information to make specific decisions.
                  </li>
                </ul>
                <p className="text-slate-dark mb-6" data-id="element-434">
                  Dr. Syed is committed to delivering independent and
                  evidence-based psychiatric evaluations. He provides detailed,
                  objective reports for solicitors, legal teams, and courts,
                  always aiming to clarify complex medical and legal questions
                  with precision and clarity.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-435">
                  Convenient & Professional Online Consultations
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-436">
                  Understanding the importance of accessibility and convenience,
                  Dr. Syed expertly conducts assessments remotely via secure
                  platforms such as Zoom, Skype, and WhatsApp Video Call. This
                  ensures that clients can receive high-standard, professional
                  evaluations from the comfort of their own environment,
                  wherever they are. His evaluations thoughtfully address
                  crucial aspects such as mental health conditions, trauma
                  history, cognitive abilities, and essential risk factors like
                  self-harm or suicidal ideation.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-437">
                  Your Assurance of Quality and Integrity
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-438">
                  Dr. Syed takes immense pride in delivering reports that are
                  not only comprehensive and tailored to legal requirements but
                  are also clear, impartial, and robustly objective. He is also
                  experienced in providing expert testimony when required,
                  working closely and effectively with solicitors to ensure all
                  case details are thoroughly understood and presented.
                </p>
                <p className="text-slate-dark mb-6" data-id="element-439">
                  With a long-standing career built on trust and ethical
                  practice, Dr. Syed ensures the utmost confidentiality,
                  meticulous attention to detail, and strict adherence to the
                  highest ethical and professional standards in all his work. He
                  is a reliable and highly respected choice for medico-legal
                  psychiatric cases.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-440">
                  Commitment to Excellence
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-441">
                  Dr. Syed is dedicated to providing independent, impartial, and
                  evidence-based reports. He is experienced in expert witness
                  testimony in Criminal, Civil, Family, and Immigration courts,
                  ensuring his insights are valuable and accessible in diverse
                  legal contexts.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-442">
                  Accessibility & Professionalism
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-443">
                  Dr. Syed offers a range of consultation options to meet your
                  needs, including remote consultations, in-person clinics,
                  prison visits, and home visits across the UK. This flexibility
                  ensures that high-quality psychiatric assessment is accessible
                  regardless of circumstances or location.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-444">
                  Ready to Discuss Your Needs?
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-445">
                  Dr. Syed welcomes the opportunity to discuss your specific
                  requirements and how his expertise can assist your case.
                  Please feel free to contact him directly through our contact
                  page.
                </p>
                <div className="mt-8" data-id="element-446">
                  <Button variant="primary" size="lg" href="/contact" data-id="element-447">
                    Instruct Dr. Syed
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}